module.exports = __webpack_public_path__ + "static/flags/BO-207f69f1d719cffa70a7a4abb95bdfd7.gif";